import ClientConfig from "shared/config";
import { ProviderType } from "./pilegateprovider";
import { getPilegateURL } from "./pilegateprovider";
import { getPileURL } from "./pileprovider";

export function getProviderType(userpool_id: string | undefined): ProviderType {
  if (!userpool_id) {
    return ProviderType.PILEGATE;
  }

  const isPileUser = ClientConfig.notMigrated.some((poolId) =>
    userpool_id.includes(poolId)
  );

  return isPileUser ? ProviderType.PILE : ProviderType.PILEGATE;
}

export function getURL(
  tenantID: string,
  usergroups: string[],
  username: string,
  poolId: string,
  thumbnailPath: string,
  providerType: ProviderType
): string {
  const userGroupsString = usergroups.join(",");
  if (providerType === ProviderType.PILE) {
    return getPileURL(tenantID, userGroupsString, username, thumbnailPath);
  } else if (providerType === ProviderType.PILEGATE) {
    return getPilegateURL(poolId, thumbnailPath);
  } else {
    throw new Error("Unknown provider type");
  }
}
